<template>
  <div class="horario-lista-agrupada">
    <v-card
      v-if="deveExibirMensagemVazia"
      outlined
      class="pa-6 text-center horario-lista-agrupada__empty"
    >
      <v-icon color="grey lighten-1" large class="mb-2">mdi-clock-alert-outline</v-icon>
      <div class="text-body-1 grey--text text--darken-1 mb-3">Nenhum registro encontrado.</div>
      <v-btn v-if="modoAdmin" color="primary" small outlined @click="$emit('nova-batida', 'dia')">
        <v-icon left small>mdi-plus</v-icon>
        Registrar Manualmente
      </v-btn>
    </v-card>

    <section v-for="grupo in grupos" :key="grupo.data" class="horario-lista-agrupada__grupo">
      <div
        class="d-flex justify-space-between align-center horario-lista-agrupada__titulo font-weight-bold"
      >
        <span>{{ grupo.titulo ?? "- - -" }}</span>
        <v-btn
          v-if="modoAdmin"
          x-small
          outlined
          color="primary"
          @click="$emit('nova-batida', grupo.data)"
        >
          <v-icon left x-small>mdi-plus</v-icon>
          Novo Registro
        </v-btn>
      </div>
      <horario-batida-card
        v-for="item in grupo.items"
        :key="item.id"
        :item="item"
        :modo-admin="modoAdmin"
        @editar="$emit('editar-batida', $event)"
        @excluir="$emit('excluir-batida', $event)"
      />
    </section>
  </div>
</template>

<script>
import HorarioBatidaCard from "./HorarioBatidaCard.vue";

export default {
  name: "HorarioListaAgrupada",
  components: {
    HorarioBatidaCard,
  },
  props: {
    registros: {
      type: [Object, Array, null],
      default: null,
    },
    consultaIniciada: {
      type: Boolean,
      default: undefined,
    },
    modoAdmin: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    possuiConsultaIniciada() {
      if (this.consultaIniciada !== undefined) {
        return this.consultaIniciada;
      }

      return this.registros !== null && this.registros !== undefined;
    },
    grupos() {
      if (!this.possuiConsultaIniciada) {
        return [];
      }

      if (Array.isArray(this.registros)) {
        return [
          {
            data: "dia",
            titulo: "Registros do dia",
            items: this.registros,
          },
        ].filter((grupo) => grupo.items.length);
      }

      return Object.keys(this.registros || {}).map((data) => {
        const items = this.registros[data] || [];
        const primeiroItem = items[0] || {};
        return {
          data,
          titulo: primeiroItem.data_formatada || data,
          items,
        };
      });
    },
    temRegistros() {
      return this.grupos.some((grupo) => grupo.items.length);
    },
    deveExibirMensagemVazia() {
      return this.possuiConsultaIniciada && !this.temRegistros;
    },
  },
};
</script>
<style scoped>
.horario-lista-agrupada__empty {
  margin-top: 0;
}

.horario-lista-agrupada__grupo + .horario-lista-agrupada__grupo {
  margin-top: 24px;
}

.horario-lista-agrupada__titulo {
  font-size: 1.1rem;
  margin-bottom: 12px;
}
</style>
